import { Phone, MapPin, Clock, Instagram, Facebook, ExternalLink } from "lucide-react";
import { business, navLinks, services, telLink, scrollToId } from "@/config/business";

export default function Footer() {
  return (
    <footer className="bg-cream border-t border-primary/10 pb-24 md:pb-0" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 py-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12">
        <div>
          <p className="font-display text-3xl font-semibold text-primary">Lavniya</p>
          <p className="text-[10px] uppercase tracking-[0.3em] text-muted-foreground mt-1">Beauty Salon</p>
          <p className="mt-5 text-sm leading-relaxed text-muted-foreground">
            Hair, beauty and grooming services in Paldi Meena, Jaipur — for everyday
            self-care and special occasions.
          </p>
          <div className="mt-6 flex gap-3">
            <a
              data-testid="footer-instagram"
              href="#"
              aria-label="Instagram (placeholder — add link before launch)"
              className="w-11 h-11 flex items-center justify-center border border-primary/20 text-primary hover:bg-primary hover:text-cream transition-colors"
            >
              <Instagram size={18} />
            </a>
            <a
              data-testid="footer-facebook"
              href="#"
              aria-label="Facebook (placeholder — add link before launch)"
              className="w-11 h-11 flex items-center justify-center border border-primary/20 text-primary hover:bg-primary hover:text-cream transition-colors"
            >
              <Facebook size={18} />
            </a>
          </div>
        </div>

        <nav aria-label="Footer">
          <h3 className="text-xs uppercase tracking-[0.2em] font-semibold text-ink">Explore</h3>
          <ul className="mt-5 space-y-3">
            {navLinks.map((l) => (
              <li key={l.id}>
                <button
                  data-testid={`footer-nav-${l.id}`}
                  onClick={() => scrollToId(l.id)}
                  className="text-sm text-muted-foreground hover:text-primary transition-colors py-1"
                >
                  {l.label}
                </button>
              </li>
            ))}
          </ul>
        </nav>

        <div>
          <h3 className="text-xs uppercase tracking-[0.2em] font-semibold text-ink">Services</h3>
          <ul className="mt-5 space-y-3">
            {services.map((s) => (
              <li key={s.title}>
                <button
                  data-testid={`footer-service-${s.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                  onClick={() => scrollToId("services")}
                  className="text-sm text-muted-foreground hover:text-primary transition-colors py-1"
                >
                  {s.title}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="text-xs uppercase tracking-[0.2em] font-semibold text-ink">Contact</h3>
          <ul className="mt-5 space-y-4 text-sm text-muted-foreground">
            <li className="flex items-start gap-3">
              <Phone size={16} className="text-accent mt-0.5 shrink-0" aria-hidden="true" />
              <a href={telLink} data-testid="footer-phone" className="hover:text-primary transition-colors">
                {business.phoneDisplay}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin size={16} className="text-accent mt-0.5 shrink-0" aria-hidden="true" />
              <span>{business.address}</span>
            </li>
            <li className="flex items-start gap-3">
              <Clock size={16} className="text-accent mt-0.5 shrink-0" aria-hidden="true" />
              <span>
                {business.hours}
                <span className="block text-[10px] uppercase tracking-widest text-accent font-semibold mt-0.5">
                  {business.verifyLabel}
                </span>
              </span>
            </li>
            <li>
              <a
                data-testid="footer-google-maps"
                href={business.googleMapsUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-1.5 text-sm font-medium text-primary hover:underline"
              >
                Google Maps <ExternalLink size={13} />
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-primary/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 py-6 flex flex-wrap items-center justify-between gap-4 text-xs text-muted-foreground">
          <p>© {new Date().getFullYear()} {business.name}. All rights reserved.</p>
          <div className="flex gap-6">
            <a href="#" data-testid="footer-privacy" className="hover:text-primary transition-colors py-2">
              Privacy Policy
            </a>
            <a href="#" data-testid="footer-terms" className="hover:text-primary transition-colors py-2">
              Terms
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
